<script setup>
import { House, UserRound, CreditCard, WalletCards } from 'lucide-vue-next';
import { useI18n } from 'vue-i18n';

defineProps({ active: String });
const { t } = useI18n();
const items = [
  { key: 'home', to: '/home', icon: House, label: () => t('nav.home') },
  { key: 'topup', to: '/topup', icon: UserRound, label: () => t('nav.topup') },
  { key: 'open', to: '/open-card', icon: CreditCard, label: () => t('nav.open') },
  { key: 'recharge', to: '/card-recharge', icon: WalletCards, label: () => t('nav.recharge') }
];
</script>

<template>
  <nav class="bottom-nav">
    <RouterLink v-for="item in items" :key="item.key" :to="item.to" :class="{ active: active === item.key }">
      <component :is="item.icon" :size="21" :stroke-width="2" />
      <span>{{ item.label() }}</span>
      <i></i>
    </RouterLink>
  </nav>
</template>

<style scoped>
.bottom-nav { position: fixed; z-index: 20; left: 50%; right: auto; bottom: calc(14px + env(safe-area-inset-bottom, 0px)); width: min(392px, calc(100vw - 28px)); height: 66px; padding: 5px; display: grid; grid-template-columns: repeat(4,1fr); align-items: center; border: 1px solid rgba(255,255,255,.07); border-radius: 20px; background: rgba(27,27,31,.94); box-shadow: 0 14px 40px rgba(0,0,0,.48); backdrop-filter: blur(18px); transform: translateX(-50%); }
.bottom-nav a { height: 54px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px; border-radius: 15px; color: #73737a; font-size: 10.5px; font-weight: 620; transition: color .2s, background .2s; }
.bottom-nav a span { max-width: 78px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
.bottom-nav a i { display: none; }
.bottom-nav a.active { color: #fff; background: linear-gradient(145deg,rgba(108,87,255,.28),rgba(83,60,242,.12)); }

@media (min-width: 600px) {
  .bottom-nav {
    bottom: calc(38px + env(safe-area-inset-bottom, 0px));
  }
}
</style>
